import { company_name } from "@/i18n/variables";

const sign_up = {
	/* -------------------------------------------------------------------------- */
	/*                                FORM SECTION                                */
	/* -------------------------------------------------------------------------- */
	form: {
		confirmation: {
			description:
				"Ihr neues Konto wurde erfolgreich registriert. Um sicherzustellen, dass wir Sie erreichen können, haben wir eine Bestätigungs-E-Mail gesendet. Sie können diese Seite jetzt schließen.",
			title: "Bestätigungs-E-Mail gesendet",
		},
		debtor_info: {
			description:
				"Bitten Sie einen Kollegen mit einem Konto, ein Konto für Sie zu erstellen, es sei denn, Ihr Unternehmen nutzt das Portal zum ersten Mal. Dann können Sie sich einmalig mit den Anmeldedaten anmelden, die Sie für klanten.tuxis.nl verwenden. Passwort von klanten.tuxis.nl vergessen? Lesen Sie <password_reset_link>>hier</password_reset_link>, wie Sie Ihr Passwort zurücksetzen können.",
			title: "Sie müssen kein Konto erstellen!",
		},
		descriptions: {
			billing: "Hier wird die Rechnung hingeschickt.",
			debtor:
				"Geben Sie unten Ihre persönlichen Daten ein, um ein Konto zu erstellen. Geschäftskunden können später weitere Personen oder Kollegen hinzufügen.",
		},
		foreign_private_debtor_warning:
			"Bitte beachten Sie! Sie können nur kostenlose Dienstleistungen in Anspruch nehmen.",
		labels: {
			accept_conditions: "Ich akzeptiere die",
			has_debtor_code: "Haben Sie bereits eine Debitorennummer?",
			privacy_policy: "Allgemeinen Geschäftsbedingungen",
		},
		password_strength: {
			bad: "Schlecht",
			good: "Gut",
			medium: "Mittel",
			okay: "Akzeptabel",
			passwords_no_match: "Passwörter stimmen nicht überein!",
			too_short: "Zu kurz",
		},
		progress_bar: {
			address: "Adress- und Unternehmensdaten",
			debtor: "Persönliche Daten",
		},
		terms: {
			label: "Allgemeine Geschäftsbedingungen",
			text: {
				part1: "Ich stimme den",
				part2: "Allgemeinen Geschäftsbedingungen",
				part3: `von ${company_name} zu.`,
			},
		},
		tips: {
			debtor_code: `Ihre Debitorennummer finden Sie auf jeder Rechnung von ${company_name}. Diese Nummer beginnt mit DB und endet mit 4 Ziffern.`,
		},
		titles: {
			account: "Ihre Kontoinformationen",
			address: "Kundendaten",
			billing: "Rechnungsdaten",
			debtor: "Ihre persönlichen Daten",
			user: "Ihre Anmeldedaten",
		},
		values: {
			no: "Nein",
			yes: "Ja",
		},
	},
	verification: {
		account_verification_card: {
			body: "Verwenden Sie den untenstehenden Link, um eine Zahlung von 0,01 € zur Verifizierung Ihrer Daten abzuschließen. Wenn Sie dies nicht selbst tun können, dürfen Sie den Link auch weiterleiten.\nNach der Zahlung erhalten Sie eine E-Mail, dass Ihr Account aktiviert wurde.",
			button: "Verifizierungszahlung starten (0,01 €)",
			title: "Account-Verifizierung",
		},
	},
};

export default sign_up;
